import React from 'react';

type Props = {
  title: React.ReactNode;
  right?: React.ReactNode;
  left?: React.ReactNode;
};

const Topbar: React.FC<Props> = ({ title, right, left }) => {
  return (
    <div className="topbar">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {left}
        <span className="topbar-title">{title}</span>
      </div>
      {right}
    </div>
  );
};

export default Topbar;
